import * as classnames from 'classnames/bind'
import * as React from 'react'
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import styles from './basic-layout.scss'

const cx = classnames.bind(styles)

type BasicLayoutProps = React.HTMLProps<HTMLLIElement> & {
  noFooter?: boolean;
  noToast?: boolean;
}
class BasicLayout extends React.Component<BasicLayoutProps> {
  public state = { showToast: !this.props.noFooter }
  public render() {
    const { className, noFooter } = this.props
    return (
      <div>
        <header className={styles.header}>
          <Navbar />
          {/* {!noToast && this.state.showToast && (
            <Toaster>
              <Toast
                message={
                  <div>
                    我們將與 TeachCake 合併，於 2019/05 全面改版。
                    <br />
                    <Link to="/changes">詳情請點此</Link>
                  </div>
                }
                intent="danger"
                timeout={0}
                onDismiss={() => this.setState({ showToast: false })}
              />
            </Toaster>
          )} */}
        </header>
        <div className={cx('main', className)}>{this.props.children}</div>
        {noFooter ? null : <Footer />}
      </div>
    )
  }
}

export default BasicLayout



// WEBPACK FOOTER //
// ./src/layouts/BasicLayout/index.tsx